<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
.totalNum{
    margin-top: 20px;
    font-weight: bold;
}
/deep/ .input-table{
    .ivu-input{
        border: 1px solid #fff;
    }
}
/deep/ .ivu-tree ul li{
    line-height: 40px;
}
/deep/ .ivu-tree-title{
    width:100%
}
/deep/ .ivu-modal-body{
    max-height: 700px;
    overflow-y: auto;
}
</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">

        <div class="cont-box" v-if="!addBox.showModel">
			<Tree :data="treeData" :render="renderContent"></Tree>
		</div>
		
       
        <SModelBox :showModel.sync="addBox.showModel" :top_id="addBox.top_id" :type="addBox.type" :fn="addBox.callbackFn" :editFormData="addBox.editFormData"></SModelBox>
    </Modal>


      
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import SModelBox from './bcAddModel';
import DeleteDialog from '@/views/common/deleteModel.vue'; // 引入删除弹框组件
import { mapState } from 'vuex'
import {toTree} from "@/libs/tools.js"

    export default {
        props: {
            showModel: Boolean,
            fn:Function
        },
        name: "Model3",
        components: {
            SModelBox,
            DeleteDialog
        },
        data() {
            return {
                loading:true,
                title: '',//弹框标题
                formData:{},
                totalNum:'20',
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                treeData:[],
                buttonList: {
				  //按钮组
				  addDisabled: false, //添加按钮是否禁用
				  editDisabled: true, //编辑按钮是否禁用
				  delDisabled: true ,//删除按钮是否禁用
				  buttonProps: {
				      type: 'default',
				      size: 'small',
				  }
				},
                addBox:{//规格弹框组-移动
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    type:1,
                    top_id:0
                },
				isOperate:false
			}
        },
        watch:{
            showModel(val){
                if(val){
                    this.getData()
                }
            }
        },
        computed:{
            ...mapState(['local','selectId']),
            titleName(){
                return [
                    {
                        title: '分类名称',
                        key: 'className',
                        minWidth: 180,
                    },
                    {
					    title: this.$t('productManage.manageModel.Operation'),
					    minWidth:120,
                        key: "id",
					    render: (h, params) => {
                            let that = this
                            return [
                                h('Button', {
					                props: {
                                        type: "error",
                                        size: 'small'
                                    },
                                    style:{
                                        display:'block',
                                        margin:'0 auto'
                                    },
					                on: {
					                    click: () => { this.todelData(params.row) }
					                }
					            },that.$t("delete"))
                            ]
					    }
					},
                ]
            }

        },
        created(){
        },
        methods: {
            async getData(){
                let res = await this.axios.post(this.config.urlArray.typeCateList, {parentClassId:null})
          
				 common.ajaxMsg(res.data,false,()=>{//提交表单后的回调处理
                        
					let childrenData = toTree(res.data.data);
				    let treedata = [{
				          title: '基础分类',
				          expand: true,
				          render: (h, { root, node, data }) => {
				              return h('span', {
				                  style: {
				                      display: 'inline-block',
				                      width: '100%',
				                      fontSize:'14px'
				                  }
				              }, [
				                  h('span', [
				                      h('span', data.className)
				                  ]),
				                  h('span', {
				                      style: {
				                          display: 'inline-block',
				                          float: 'right',
				                          marginRight: '32px'
				                      }
				                  }, [
				                      h('Button', {
				                          props: Object.assign({}, this.buttonList.buttonProps, {
				                              icon: 'ios-add',
				                              type: 'primary'
				                          }),
				                          style: {
				                              width: '64px'
				                          },
				    					  attrs: {
                                              title: '添加一级分类'
                                          },
				                          on: {
				                              click: () => { this.append(data,1) }//添加顶级分类
				                          }
				                      })
				                  ])
				              ]);
				          },
				          children: childrenData
				      }]
				      this.treeData = treedata;
                        
                    },()=>{
                       
                    })


				
            },
            openOrClose(value) {
                if(value === true) {        
                    this.title = this.$t('BasicProduct.titleName.basicClassId')
                } else { //关闭弹框后要做的处理
                   
					if(this.isOperate){
                       this.fn()
					}
					this.resetForm();//重置表单
					
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
				this.isOperate = false
            },
            renderContent (h, { root, node, data }) {
			    let color = '#13C351'
			    let status = '显示'
			
			    // switch (data.status){
			    //     case 1:
			    //     color = '#13C351'
			    //     status = '显示'
			    //     break
			    //     case 2:
			    //     color = '#f00'
			    //     status = '隐藏'
			    //     break
			    //     default:
			    //     color = '#f00'
			    //     status = '未知'
			
			    // }
			    
			    return h('div', {
			        style: {
			            display: 'inline-block',
			            width: '100%',
                        padding:'0 30px',
			            fontSize:'14px',
			            lineHeight:'40px',
			            borderBottom:'1px solid #ccc',
			        }
			    }, [
			        h('span', [
			            h('span', data.className)
			        ]),
			        h('span', {
			                style: {
			                    display: 'inline-block',
			                    float: 'right',
			                    marginRight: '32px'
			                }
			            }, 
                    [
			            // h('img', {
			            //     attrs: {
			            //         src:this.config.sourceUrl +  data.thumb
			            //     },
			            //     style: {
			            //         marginRight: '150px',
			            //         width:'30px',
			            //         height:'30px',
			            //         verticalAlign:'middle'
			            //     }
			            // }),
			            // h('span', {
			            //     style: {
			            //         marginRight: '150px',
			            //         color:color
			            //     }
			            // },status),
			            h('Button', {
			                props: Object.assign({}, this.buttonList.buttonProps, {
			                    icon: 'md-add'
			                }),
			                style: {
			                    marginRight: '8px'
			                },
							attrs: {
                                title: '创建'+data.className+'分类所属子分类'
                            },
			                on: {
			                    click: () => { this.append(data,1) }//添加子分类
			                }
			            }),
			            h('Button', {
			                props: Object.assign({}, this.buttonList.buttonProps, {//
			                    icon: 'ios-create-outline'
			                }),
			                style: {
			                    marginRight: '8px'
			                },
							attrs: {
                                title: '编辑'+data.className+'分类名称'
                            },
			                on: {
			                    click: () => { this.append(data,2) }//编辑分类
			                }
			            }),
			            h('Poptip',{
			                props:{
			                   confirm:true,
			                    title:this.$t('delete')+'?',
			                },
			                on:{
			                    'on-ok':()=>{this.remove(root, node, data)}
			                }
			            },
			            [
			                h('Button', {
			                props: Object.assign({}, this.buttonList.buttonProps, {
			                    icon: 'ios-remove'
			                })
			            })
			            ]
			            )
			            
			        ])
			    ]);
			},
			append (data,type) {//添加编辑分类方法
			
				this.addBox.type = type
                this.addBox.top_id = data.nodeKey
                this.addBox.editFormData = data;

				// if(type){
				// 	this.top_id = data.parentClassId;

				// 	if(type==2){
				// 		this.addBox.editFormData = data;
				// 		this.top_id = '0';
				// 	}
				// }else{
				// 	this.top_id = '0'
				// }
				this.addBox.showModel = true
				this.addBox.callbackFn = () => {//回调处理
					//重新载入
					this.clearbtnStatus()
					this.addBox.showModel = false;
					this.getData();
					this.isOperate = true
				} 
			},
			remove (root, node, data) {//删除分类方法
			    // if(data.children&&data.children.length > 0){
			    //     common.msg('error',this.$t('BasicProduct.basicClassBox.errorInfo'),()=>{})
			    //     return;
			    // }
			    this.axios.post(this.config.urlArray.deleteBasicClasses,{id:data.id}).then((result)=>{
			        common.ajaxMsg(result.data,true,()=>{
			            //重新载入
			            this.clearbtnStatus()
			            this.getData();
						this.isOperate = true
			        })
			    }).catch((err) => {
			         common.msg('error','删除失败',()=>{})
			    })
			},
			clearbtnStatus(){ //删除后清空编辑数据 与按钮状态
			    this.addBox.editFormData ={}
			}
        }
    }
</script>
